import { NavLink, Link, useLocation } from "react-router-dom";
import { Users, GitCompare, ScrollText, ListChecks, Home } from "lucide-react";
import { useLang } from "@/context/LangContext";

const TABS = [
  { to: "/", key: "nav_home", icon: Home, end: true, id: "home" },
  { to: "/", key: "nav_leaders", icon: Users, end: true, id: "leaders" },
  { to: "/changes", key: "nav_changes", icon: GitCompare, id: "changes" },
  { to: "/schemes", key: "nav_schemes", icon: ScrollText, id: "schemes" },
  { to: "/candidates", key: "nav_candidates", icon: ListChecks, id: "candidates", also: "/c/" },
];

export function GeneralLinks() {
  const { t, lang } = useLang();
  const cls = `whitespace-nowrap text-[12px] font-semibold text-indigo-100/85 hover:text-white underline-offset-4 hover:underline ${lang === "ta" ? "font-tamil" : ""}`;
  return (
    <nav className="flex flex-wrap items-center gap-x-3 gap-y-1 max-w-full" data-testid="header-general-links">
      <Link to="/about" className={cls} data-testid="header-about-link">{t("about_link")}</Link>
      <Link to="/media" className={cls} data-testid="header-media-link">{t("media_link")}</Link>
      <Link to="/contact" className={cls} data-testid="header-contact-link">{t("contact_link")}</Link>
    </nav>
  );
}

export default function SiteNav() {
  const { t, lang } = useLang();
  const path = useLocation().pathname;
  return (
    <nav className="mt-6 -mx-1 flex sm:flex-wrap gap-1.5 overflow-x-auto pb-1 no-scrollbar" data-testid="site-nav">
      {TABS.map(({ to, key, icon: Icon, end, id, also }) => (
        <NavLink
          key={id}
          to={to}
          end={end}
          className={({ isActive }) =>
            `shrink-0 inline-flex items-center gap-2 rounded-full px-4 py-2 text-[13px] font-semibold transition-colors ${
              id === "home" ? "bg-[#f2b705] text-[#1a1640] hover:bg-[#ffc928]" : isActive || (also && path.startsWith(also)) ? "bg-white text-[#1a1640]" : "bg-white/10 text-white hover:bg-white/20"
            } ${lang === "ta" ? "font-tamil" : ""}`
          }
          data-testid={`nav-tab-${id}`}
        >
          <Icon size={15} />
          {t(key)}
        </NavLink>
      ))}
    </nav>
  );
}
